import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { SubscriptionProvider } from '@/contexts/SubscriptionContext';
import { Toaster } from '@/components/ui/sonner';
import ProtectedRoute from '@/components/ProtectedRoute';
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import Dashboard from '@/pages/Dashboard';
import ResumeBuilder from '@/pages/ResumeBuilder';
import SubscriptionPage from '@/pages/SubscriptionPage';
import SharedResumePage from '@/pages/SharedResumePage';
import AuthCallbackPage from '@/pages/AuthCallbackPage';
import ResumeUploadPage from '@/pages/ResumeUploadPage';
import ATSOptimizerPage from '@/pages/ATSOptimizerPage';
import OnePageBuilder from '@/pages/OnePageBuilder';
import JobSearchPage from '@/pages/JobSearchPage';
import ReferAndEarnPage from '@/pages/ReferAndEarnPage';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/shared/:shareToken" element={<SharedResumePage />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/builder/:id" element={<ProtectedRoute><ResumeBuilder /></ProtectedRoute>} />
              <Route path="/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
              <Route path="/upload" element={<ProtectedRoute><ResumeUploadPage /></ProtectedRoute>} />
              <Route path="/ats-optimizer/:id" element={<ProtectedRoute><ATSOptimizerPage /></ProtectedRoute>} />
              <Route path="/one-page-builder" element={<ProtectedRoute><OnePageBuilder /></ProtectedRoute>} />
              <Route path="/job-search" element={<ProtectedRoute><JobSearchPage /></ProtectedRoute>} />
              <Route path="/refer-and-earn" element={<ProtectedRoute><ReferAndEarnPage /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </SubscriptionProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
